import axios from "axios";
import { executeApiRequest } from "@/plumbing/http/apiClient";
import { UserEmail } from ".";

export type listUserEmailResponse = {
  userEmails: UserEmail[];
};

export const listUserEmails = async () => {
  const response = await executeApiRequest(() => axios.get<listUserEmailResponse>("/monthlyReports/userEmails"), false);

  return response?.data.userEmails;
};
